import { useEffect } from "react";
import { useInvitation } from "../../../Context/Invitation/InvitationContext";
import Loader from "../../Shared/Loader/loader";
import { getInvitations } from "../../../API/Tenant/Tenant";
import { SET_INVITATIONS, SET_LOADING } from "./InvitationEvents";
import { useGlobalContext } from "../../../Renderers/GlobalContext";
import InvitationGrid from "./Components/InvitationGrid";
import RejectInvitationDialog from "./Components/RejectInvitationDialog";
import AcceptInvitationDialog from "./Components/AcceptInvitationDialog";
import InvitationNotification from "./Components/InvitationNotification";
import { getCurrentSubscriptionForOrganisation } from "../../../API/Payment/Payment";

const Invitation = () => {
    const { state, dispatch } = useInvitation();
    const { state: globalState, dispatch: globalDispatch } = useGlobalContext();
    const { user, organization } = globalState;

    useEffect(() => {
        const fetchInvitationData = async () => {
            try {
                const [invitations, subscription] = await Promise.all([
                    getInvitations(organization._id),
                    getCurrentSubscriptionForOrganisation(organization._id),
                ]);
                dispatch({ type: SET_INVITATIONS, payload: invitations });
                globalDispatch({ type: "SET_SUBSCRIPTION", payload: subscription });
            } catch (error) {
                console.error(error);
            } finally {
                dispatch({ type: SET_LOADING, payload: false });
            }
        }
        if (user && user._id) {
            fetchInvitationData();
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (state.loading) return <Loader />

    return (
        <div className="m-3">
            {state.showAcceptInvitationDialog && <AcceptInvitationDialog />}
            {state.showRejectInvitationDialog && <RejectInvitationDialog />}
            {state.showNotification && <InvitationNotification />}
            <InvitationGrid />
        </div>
    );
}
export default Invitation;